import { render, staticRenderFns } from "./TransactionsForm.vue?vue&type=template&id=7dd4e4f2&scoped=true&"
import script from "./TransactionsForm.vue?vue&type=script&lang=js&"
export * from "./TransactionsForm.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsForm.vue?vue&type=style&index=0&id=7dd4e4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd4e4f2",
  null
  
)

export default component.exports